import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Ore passate a preparare ogni allenamento',
  lines: ['Ogni settimana devi creare nuove lezioni. Scegliere gli esercizi. Preparare progressioni. Adattare ogni attività al livello dei tuoi clienti. Organizzare circuiti. Pianificare ogni seduta. Aggiornare continuamente i programmi.', 'E prima ancora di iniziare la prima lezione... Hai già trascorso ore davanti al computer.']
}, {
  emoji: '🤔',
  title: 'Ogni gruppo è diverso e richiede continue modifiche',
  lines: ['Alcuni clienti hanno ottima mobilità. Altri presentano rigidità articolare. Alcuni hanno problemi di equilibrio. Altri hanno limitazioni fisiche o livelli di allenamento completamente diversi.', 'Ogni volta devi modificare esercizi, adattare progressioni e ripensare l\'intera lezione. Preparare tutto da zero richiede sempre moltissimo tempo.']
}, {
  emoji: '📚',
  title: 'Hai tantissimo materiale... ma niente è davvero organizzato',
  lines: ['Libri. PDF. Video. Articoli. Corsi. Appunti. Hai accumulato tantissime informazioni negli anni.', 'Ma ogni volta devi cercare, selezionare, adattare e ricostruire tutto. Ti manca un sistema unico, professionale e già pronto da utilizzare.']
}, {
  emoji: '😩',
  title: 'Sempre meno tempo per seguire davvero i tuoi clienti',
  lines: ['Tra pianificazioni... Lezioni... Programmi... Adattamenti... Valutazioni... Monitoraggio... Documentazione...', 'Passi sempre più tempo a preparare il materiale che ad allenare le persone.']
}];
export function PainSection() {
  return <section className="py-8 px-4 sm:px-6 bg-cream" data-id="element-100" data-mp="3io5nu8t0dk3v">
      <h2 className="text-xl sm:text-3xl font-heading font-extrabold text-center text-petrol mb-2 leading-tight uppercase" data-id="element-101" data-mp="3dukw2yi0dmd4">
        Ti Ritrovi in Una di Queste Situazioni?
      </h2>

      <p className="text-sm sm:text-base text-warmgray text-center mb-6 max-w-2xl mx-auto leading-snug" data-id="element-102" data-mp="2l7qfwds8595g">
        Ami aiutare le persone senior a vivere meglio attraverso il movimento.
        Ma preparare ogni lezione richiede sempre più tempo.{' '}
        <span className="font-semibold text-petrol" data-id="element-103" data-mp="u0sm83ncwy2a">
          Se lavori in palestra, in uno studio, in un centro fitness, in
          associazioni sportive o come Personal Trainer specializzato nel fitness
          senior, probabilmente ti riconoscerai in una di queste situazioni.
        </span>
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-4xl mx-auto" data-id="element-104" data-mp="67at3omlsjl9">
        {pains.map(pain => <div key={pain.title} className="bg-white p-4 rounded-lg border-l-4 border-gold shadow-sm" data-id="element-105" data-mp="f5mi5m7tn9bl">
            <h3 className="text-sm sm:text-base font-heading font-bold text-petrol mb-1.5 leading-snug" data-id="element-106" data-mp="k5se3el4jhzh">
              <span aria-hidden="true" data-id="element-107" data-mp="1qjzzs9bzesj6">{pain.emoji}</span> {pain.title}
            </h3>
            {pain.lines.map((line, j) => <p key={j} className="text-warmgray text-[13px] sm:text-sm leading-relaxed mb-1.5 last:mb-0" data-id="element-108" data-mp="1vlz0fbgc7bcf" data-mpi={j}>
                {line}
              </p>)}
          </div>)}
      </div>
    </section>;
}